module.exports = __webpack_public_path__ + "static/media/nwhacks2021.32bc98ff.jpg";